/**
 * Customer portal loader only.
 * Runs on:
 *   /pages/subscriptions          (list)
 *   /pages/subscriptions?c=...    (single subscription)
 *   /pages/payment-method
 *   /pages/custom-offer
 */
(function () {
  var path = window.location.pathname || "";
  var isPaymentMethod =
    path.indexOf("/pages/payment-method") !== -1 ||
    path.indexOf("/pages/payment_method") !== -1;
  var isSubscriptions = path.indexOf("/pages/subscriptions") !== -1;
  var isCustomOffer = path.indexOf("/pages/custom-offer") !== -1;

  if (!isPaymentMethod && !isSubscriptions && !isCustomOffer) {
    return;
  }

  var domainName =
    typeof Shopify !== "undefined" && Shopify.shop ? Shopify.shop : "";

  function appendAjaxResponseToDOM(response) {
    if (!response) return;

    var container = document.createElement("div");
    container.innerHTML = response;

    var button = container.querySelector("button.confirmpayment");
    if (button) {
      document.body.appendChild(button);
    }

    container.querySelectorAll("script").forEach(function (script) {
      var newScript = document.createElement("script");
      if (script.src) {
        newScript.src = script.src;
      } else {
        newScript.textContent = script.textContent;
      }
      document.body.appendChild(newScript);
    });
  }

  function renderPortal(result) {
    if (!result) return;
    var subs = document.querySelector("#fetchhw-subs");
    if (!subs) return;
    subs.innerHTML = result.returnhtml || "";
    appendAjaxResponseToDOM(result.paystackjs);
  }

  function postJson(url, data) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
      redirect: "follow",
    }).then(function (response) {
      return response.json();
    });
  }

  function loadPortal() {
    if (isPaymentMethod) {
      if (!domainName) return;
      postJson("https://subscriptions.gosimple.app/api/subscriptionsByemail", {
        action: "subsbyemail",
        myshopifyDomain: btoa(domainName),
      })
        .then(renderPortal)
        .catch(function (error) {
          console.error("Error:", error);
        });
      return;
    }

    var subscriptionCode = new URLSearchParams(window.location.search).get("c");
    if (subscriptionCode) {
      postJson("https://subscriptions.gosimple.app/api/subscription-detail", {
        action: "subscripitonDetail",
        code: subscriptionCode,
      })
        .then(renderPortal)
        .catch(function (error) {
          console.error("Error:", error);
        });
      return;
    }

    var customerInput = document.querySelector('input[name="hws-customer"]');
    if (customerInput && domainName) {
      postJson("https://subscriptions.gosimple.app/api/subscriptions", {
        myshopifyDomain: btoa(domainName),
        customer: btoa(customerInput.value),
      })
        .then(renderPortal)
        .catch(function (error) {
          console.error(error);
        });
      return;
    }

    var subs = document.querySelector("#fetchhw-subs");
    if (subs) subs.innerHTML = "";
  }

  setTimeout(loadPortal, 300);
})();
